<template lang="pug">
  .child-wrap
    .child-content
      .prefix(@click="toggleSubChildren()")
        i(v-if="hasSubChildren" :class="show ? 'el-icon-caret-bottom' : 'el-icon-caret-right'")
      lei-link.record(
      :to="{name: 'RecordDetailsPage', params: {id: child.id}}",
      :with-challenge="true"
      @more="showRelationship"
      :custom-color="handleRelationshipStatus(type, child.id)")
        p {{childName}}
        p(slot="append") ({{type}})
    .sub-children(v-if="show && hasSubChildren")
      child-link(
        v-for="(record, i) in children",
        :key="i",
        :child="record",
        :parent="child"
        :relationships="childrenRelationships"
        :subChild="true"
        )
      show-more(v-if="showButton", @show-more="showMoreChildren", align="left")
    .empty(v-if="show && !hasSubChildren")
      p.info No direct child data available for {{childName}}
</template>
<script>
import { mapActions, mapMutations, mapState, } from 'vuex'
import { TOGGLE_RELATIONSHIP_MODAL, } from '../../store/modules/record/mutations-types'
import { parseRecord, getCompanyName, } from '../../store/modules/record/helpers/parsing'
import LeiLink from '../lei-components/LeiLink'
import ShowMore from '@/components/record-details/ShowMore'

export default {
  name: 'ChildLink',
  components: {
    ShowMore,
    LeiLink,
  },
  props: {
    child: {
      type: Object,
      required: true,
    },
    relationships: {
      type: Array,
      default: () => [],
    },
    subChild: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: 'Direct',
    },
  },
  data () {
    return {
      children: [],
      childrenRelationships: [],
      received: false,
      receivedRelationships: false,
      show: false,
      childrenPage: 1,
      lastPage: 1,
    }
  },
  computed: {
    showButton () {
      return this.childrenPage < this.lastPage
    },
    childName () {
      return getCompanyName(this.child)
    },
    hasSubChildren () {
      return !!this.child.relationships['direct-children']
    },
    ...mapState('record', [ 'ultimateChildrenRelationships', 'directChildrenRelationships', ]),
  },
  methods: {
    showRelationship () {
      this.getRelationships({
        id: this.child.id,
        type: this.type === 'Direct' ? 'direct-parent-relationship' : 'ultimate-parent-relationship',
        cb: ({ data, }) => {
          const { child, parent, } = this
          this.getEntitiesLeiIssuer({
            id: this.child.id,
            registration: data.attributes.registration,
          })
            .then(() => {
              this.showMore({
                show: true,
                child,
                parent,
                info: parseRecord(data),
              })
            })
        },
      })
    },
    showRecordDetails (id) {
      this.$router.push({
        name: 'RecordDetailsPage',
        params: { id: id, },
      })
    },
    toggleSubChildren () {
      this.show = !this.show
      if (!this.received && this.show && !this.receivedRelationships) {
        this.getChildren()
        this.getSubChildrenRelationships()
      }
    },
    getChildren () {
      if (this.hasSubChildren) {
        this.getSubChildren({
          id: this.child.id,
          page: this.childrenPage,
        })
          .then(({ data, meta, }) => {
            this.lastPage = meta.pagination.lastPage
            this.received = true
            this.children = [ ...this.children, ...data.map((child) => parseRecord(child)), ]
          })
      }
    },
    getSubChildrenRelationships () {
      if (this.hasSubChildren) {
        this.getSubRelationships({
          id: this.child.id,
          page: this.childrenPage,
        })
          .then(({ data, }) => {
            this.receivedRelationships = true
            this.childrenRelationships = [ ...this.childrenRelationships, ...data, ]
          })
      }
    },
    showMoreChildren () {
      this.childrenPage++
      this.getChildren()
      this.getSubChildrenRelationships()
    },
    handleRelationshipStatus (type, id) {
      if (this.subChild){
        for (const element of this.relationships) {
          if (element.attributes.relationship.startNode.id === id) {
            return element.attributes.registration.status
          }
        }
      } else {
        for (const element of this.directChildrenRelationships) {
          if (element.attributes.relationship.startNode.id === id) {
            return element.attributes.registration.status
          }
        }
      }
    },
    ...mapActions('record', [
      'getSubChildren',
      'getSubRelationships',
      'getRelationships',
      'getEntitiesLeiIssuer',
    ]),
    ...mapMutations('record', {
      showMore: TOGGLE_RELATIONSHIP_MODAL,
    }),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .child-wrap
    display flex
    flex-direction column

    .lapsed
      text-decoration: underline #CD5C5C
      text-underline-offset: 3px
      text-decoration-thickness: 2px

    .published
      text-decoration: underline #4682B4
      text-underline-offset: 3px
      text-decoration-thickness: 2px

    .record
      flex-grow 1

    .child-content
      display flex
      align-items center
      position relative
      margin-bottom 1rem

      .prefix
        cursor pointer
        font-size 120%
        color $default-color
        width 1.5rem

    .sub-children, .empty
      padding-left 1.5rem

      .align-start
        justify-content flex-start

    .empty
      font-size 95%
      color $default-color-middle
</style>



// WEBPACK FOOTER //
// src/components/record-details/ChildLink.vue